<!-- tap on top starts-->
<div class="tap-top" style="background-color: #00a6b6 !important; box-shadow: 0 0 10px rgb(0 166 182); " (click)="tapToTop()" 
  [ngStyle]="{ 'display': show ? 'block' : 'none' }">
  <app-feather-icons [icon]="'chevrons-up'"></app-feather-icons>
</div>
<!-- tap on tap ends-->